import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 260 + 'px',
      points: '',
      grandTotalPoints: '',
      usePoints: '',
      type: '0'
    }
  },
  computed: {
    ...mapState('myPointsModule', ['myPointsList']),
    myPointsListInfo () {
      return this.myPointsList
    }
  },
  methods: {
    ...mapActions('myPointsModule', ['getMemberPointsChangeLogPageList']),
    goBack (item) {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER,
        query: {}
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    changeTitleType (type) {
      this.typeName = type
    },
    getMemberPointsChangeLogPageListInfo (type) {
      if (type) {
        this.type = type
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder
      }
      if (this.type !== '0') {
        pageData.expenditureOrIncome = type * 1
      }
      this.getMemberPointsChangeLogPageList(pageData)
    },
    load () {
      this.pageSize += 10
      this.getMemberPointsChangeLogPageListInfo(this.type)
    }
  },
  mounted () {
    document.title = '我的积分'
    this.usePoints = this.$route.query.usePoints
    this.grandTotalPoints = this.$route.query.grandTotalPoints
    this.points = this.$route.query.points
    this.getMemberPointsChangeLogPageListInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/views/my-points.js